import { securedApiRequest } from "./SecuredApi";

/**
 * Fetches testimonials from the backend.
 *
 * @returns {Promise<Array>} - An array of testimonial objects.
 * @throws Will throw an error if the API request fails.
 */
export const fetchTestimonials = async () => {
    const response = await securedApiRequest("/get-testimonials/", "GET", null,false);
    return response.testimonials || [];
};
